import {NgModule} from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {CoreModule} from '../../core/core.module';
import {SharedUiModule} from '@comm-apps/shared-ui';
import {AgGridModule} from 'ag-grid-angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {DirtyGuard} from "../../../../../../libs/common/src/lib/guard/dirty.guard";
import { SimpleViewComponent } from '../../core/simple-view/simple-view.component';
import { QPTMComponent } from './qptm/qptm-request.component';
import { RecaptchaFormsModule, RecaptchaModule, RecaptchaV3Module } from 'ng-recaptcha';
import { NotFoundComponent } from './not-found/not-found.component';
import { TIPSComponent } from './tips/tips-request.component';
import { CadCommonModule } from '@comm-apps/common';
import { PEComponent } from './pe/pe-request.component';
import { FGComponent } from './fg/fg-request.component';
import { ETComponent } from './et/et-request.component';
import { SubmitSuccessfulComponent } from './submit-successful/submit-successful.component';
import { EnableComponent } from './enable/enable-request.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: NotFoundComponent,
        pathMatch: 'full',
      },
      {
        path: 'qptm', 
        component: QPTMComponent, 
        pathMatch: 'full',
        canDeactivate: [DirtyGuard],
      },
      {
        path: 'tips', 
        component: TIPSComponent, 
        pathMatch: 'full',
        canDeactivate: [DirtyGuard],
      },
      {
        path: 'pe', 
        component: PEComponent, 
        pathMatch: 'full',
        canDeactivate: [DirtyGuard],
      },
      {
        path: 'fg', 
        component: FGComponent, 
        pathMatch: 'full',
        canDeactivate: [DirtyGuard],
      },
      {
        path: 'enable', 
        component: EnableComponent, 
        pathMatch: 'full',
        canDeactivate: [DirtyGuard],
      },
      {
        path: 'et', 
        component: ETComponent, 
        pathMatch: 'full',
        canDeactivate: [DirtyGuard],
      },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    CoreModule,
    CommonModule,
    SharedUiModule,
    AgGridModule,
    FormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    CadCommonModule
  ],
  declarations: [NotFoundComponent, QPTMComponent, TIPSComponent, PEComponent, FGComponent, EnableComponent, ETComponent, SubmitSuccessfulComponent]
})
export class RequestModule {
}
